import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges
} from '@angular/core';
import moment from 'moment';
import * as fromDataServices from '../../../data-services';
import * as fromShared from '../../../shared';
import { FilterService } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
@Component({
    selector: 'ef-invoice-register-presenter',
    templateUrl: './invoice-register-presenter.component.html',
    styleUrls: ['./invoice-register-presenter.component.scss'],
    standalone: false
}) // , OnChanges
export class InvoiceRegisterPresenter
    extends fromShared.EditGrid<fromDataServices.InvoiceRegister.InvoiceRegisterModel>
    implements OnInit, OnChanges
{
    @Input() SelectedContracts: string[] = [];
    @Input() InvoiceNumber: string;
    numCols = 10;
    cols = [
        { header: 'Start', field: 'InvoiceStart', class: 'date' },
        { header: 'End', field: 'InvoiceEnd', class: 'date' },
        { header: 'Contract', field: 'FullName' },
        { header: 'Invoice Number', field: 'InvoiceNbr' },
        { header: 'Cost/Calc Type', field: 'CalcType' },
        { header: 'Hours', field: 'ActualHours' },
        { header: 'Unloaded Amt', field: 'InvoiceAmount', class: 'currency' },
        { header: 'Loaded Amt', field: 'LoadedAmt', class: 'currency' },
        { header: 'Total Amt', field: 'PeriodTotal', class: 'currency' }
    ];
    rowGroupMetadata: any = {};
    dateFilters: any = null;
    moment: any;

    constructor(
        private log: LoggingService,
        private filterService: FilterService
    ) {
        super();
        this.moment = moment;
    }

    ngOnInit(): void {
        this.addDateRangeFilter();
    }
    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (changes && changes.items && changes.items.currentValue) {
            this.updateRowGroupMetaData(changes.items.currentValue);
        }
        if (changes && changes.SelectedContracts) {
            if (changes.SelectedContracts.currentValue) {
                this.dataTable.filter(
                    changes.SelectedContracts.currentValue,
                    'listid',
                    'in'
                );
            } else {
                this.dataTable.filter('', 'listid', 'contains');
            }
        }
        if (changes && changes.InvoiceNumber) {
            if (changes.InvoiceNumber.currentValue) {
                this.dataTable.filter(
                    changes.InvoiceNumber.currentValue,
                    'InvoiceNbr',
                    'contains'
                );
            } else {
                this.dataTable.filter('', 'InvoiceNbr', 'contains');
            }
        }
    }
    onFilter($event) {
        this.log.verbose({
            type: 'InvoiceRegisterPresenter:onFilter',
            $event
        });
        this.updateRowGroupMetaData($event.filteredValue);
    }
    updateRowGroupMetaData(
        items: fromDataServices.InvoiceRegister.InvoiceRegisterModel[]
    ) {
        this.rowGroupMetadata = {};
        if (items) {
            for (let i = 0; i < items.length; i++) {
                const rowData = items[i];
                const index = rowData.groupIndex;

                if (i === 0) {
                    this.rowGroupMetadata[index] = {
                        index: 0,
                        indexEnd: 0,
                        size: 1,
                        contract: rowData.FullName,
                        invoiceNumber: rowData.InvoiceNbr,
                        fee: rowData.FeeCost,
                        hours: rowData.ActualHours,
                        unloaded: rowData.InvoiceAmount,
                        loaded: rowData.LoadedAmt,
                        total: rowData.PeriodTotal
                    };
                } else {
                    const previousRowData = items[i - 1];
                    const previousRowGroupIndex = previousRowData.groupIndex;
                    if (index === previousRowGroupIndex) {
                        this.rowGroupMetadata[index].size++;
                        this.rowGroupMetadata[index].indexEnd++;
                        this.rowGroupMetadata[index].fee += rowData.FeeCost;
                        this.rowGroupMetadata[index].hours +=
                            rowData.ActualHours;
                        this.rowGroupMetadata[index].unloaded +=
                            rowData.InvoiceAmount;
                        this.rowGroupMetadata[index].loaded +=
                            rowData.LoadedAmt;
                        this.rowGroupMetadata[index].total +=
                            rowData.PeriodTotal;
                    } else {
                        this.rowGroupMetadata[index] = {
                            index: i,
                            indexEnd: i,
                            size: 1,
                            contract: rowData.FullName,
                            invoiceNumber: rowData.InvoiceNbr,
                            fee: rowData.FeeCost,
                            hours: rowData.ActualHours,
                            unloaded: rowData.InvoiceAmount,
                            loaded: rowData.LoadedAmt,
                            total: rowData.PeriodTotal
                        };
                    }
                }
            }
        }
        this.log.verbose({
            type: 'InvoiceRegisterPresenter:updateRowGroupMetaData',
            rowGroupMetadata: this.rowGroupMetadata
        });
    }
    addDateRangeFilter() {
        this.filterService.register(
            'dateRangeFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceRegisterPresenter:addDateRangeFilter',
                    value,
                    filter,
                    dateFilters: this.dateFilters,
                    result: moment(value).isBetween(
                        moment(this.dateFilters[0]),
                        moment(this.dateFilters[1])
                    )
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.dateFilters[0]),
                    moment(this.dateFilters[1])
                );
                // get the from/start value
            }
        );
    }
}
